import { atom } from "jotai";
import { ControlFlowGraph } from "../../Resources/SolidityParser";

export const CFGAtom = atom(null as ControlFlowGraph);